import { Grid } from '@mui/material';
import {
  Today, AttachMoney, CheckCircle, Schedule, HourglassTop,
} from '@mui/icons-material';
import KPICard from './KPICard';
import type { DashboardStats } from '../../hooks/useDashboardStats';

interface Props {
  stats: DashboardStats;
  onNavigate?: (path: string) => void;
}

const KPICardRow = ({ stats, onNavigate }: Props) => {
  const cards = [
    {
      icon: <Today />,
      label: '오늘 신청',
      value: `${stats.todayCount}건`,
      accentColor: '#1976d2',
      change: stats.todayChange,
      changeLabel: 'vs 어제',
      onClick: () => onNavigate?.('/admin/orders'),
    },
    {
      icon: <AttachMoney />,
      label: '이번 달 매출',
      value: `${stats.thisMonthRevenue > 0 ? `₩${(stats.thisMonthRevenue / 10000).toFixed(0)}만` : '₩0'}`,
      accentColor: '#16a34a',
      change: stats.monthRevenueChange,
      changeLabel: 'vs 지난달',
    },
    {
      icon: <CheckCircle />,
      label: '완료율',
      value: `${stats.completionRate}%`,
      accentColor: '#7c3aed',
      change: null,
    },
    {
      icon: <HourglassTop />,
      label: '진행중',
      value: `${stats.inProgressCount}건`,
      accentColor: '#ea580c',
      change: null,
      onClick: () => onNavigate?.('/admin/orders?status=진행중'),
    },
    {
      icon: <Schedule />,
      label: '평균 처리시간',
      value: stats.avgProcessingDays > 0 ? `${stats.avgProcessingDays}일` : '-',
      accentColor: '#0891b2',
      change: null,
    },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {cards.map((card) => (
        <Grid item xs={6} sm={4} md key={card.label}>
          <KPICard {...card} />
        </Grid>
      ))}
    </Grid>
  );
};

export default KPICardRow;
